__turbopack_context__.v({
  "arrow": "SectionArrow-module__ovn8UW__arrow",
  "arrowBounce": "SectionArrow-module__ovn8UW__arrowBounce",
  "arrowIn": "SectionArrow-module__ovn8UW__arrowIn",
  "container": "SectionArrow-module__ovn8UW__container",
});
